/**
 * Used to express a non-defined value in DB and easily translate it when necessary.
 */
export const NONE_VALUE = 'NONE';
